<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
        <CCard>
          <CCardBody>
            <CButton color="primary" @click="create()"
              ><CIcon name="cil-plus" /> Create New Currency</CButton
            >
            <br />
            <br />
            <br />
            <CAlert :color="alertType" v-if="message"> {{ message }}</CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="50"
              pagination
            >
              <template #currencyCode="{ item }">
                <td>
                  <strong>{{ item.currencyCode }}</strong>
                </td>
              </template>
              <template #DELETE="{ item }">
                <td>
                  <CButton color="danger" @click="deleteCurrency(item.id)"
                    >Delete</CButton
                  >
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";

export default {
  name: "PartnerCurrencies",
  data: () => {
    return {
      token: localStorage.getItem("api_token"),
      partnerId: localStorage.getItem("partner_id"),

      items: [],
      fields: ["currencyCode", "DELETE"],

      //Alert
      alertType: "danger",
      message: null,
    };
  },
  computed: {},
  methods: {
    getRowCount(items) {
      return items.length;
    },
    deleteCurrency(id) {
      let self = this;
      axios
        .delete(
          `${this.$apiAdress}/v1/PartnerCurrency/${id}`
        )
        .then(function () {
                    self.alertType = "success";
          setTimeout(function () {
              self.message = null;
          }, 5000);
          self.message = "Successfully deleted currency.";
          self.getList();
        })
        .catch(function (error) {
                    self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
          self.message = error;
        });
    },
    create() {
      this.$router.push({ path: "currencies/create" });
    },

    getList() {
      let self = this;
      axios
        .get(`${this.$apiAdress}/v1/PartnerCurrency`)
        .then(function (response) {
          self.items = response.data;
        })
        .catch(function (error) {
                    self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
          self.message = error;
        });
    },
  },
  mounted: function () {
    this.getList();
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
